import { gql } from '@apollo/client';

const HELP_ALL_TOPICS_AND_ARTICLES = gql`query getAllTopicsAndArticles{
	helpContext {
		allTopics {
			topicId: id
			parentTopicId: parentId
			index
			title: name
			description
		}
		allArticles {
			articleId: id
			topicId
			title
			description
			content
			related
			tags
		}
	}
}
`;

export default HELP_ALL_TOPICS_AND_ARTICLES;
